import { render, staticRenderFns } from "./contactImportFromExcel.vue?vue&type=template&id=2fe36b44&scoped=true"
import script from "./contactImportFromExcel.vue?vue&type=script&lang=js"
export * from "./contactImportFromExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe36b44",
  null
  
)

export default component.exports